import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { matchMedia } from '../../helpers/match-media'
import style from './index.module.scss'

// If the full text content fits into (minLines + buffer), just show everything by default
const BUFFER_LINES = 2

class ShowMoreText extends Component {
  constructor(props) {
    super(props)
    this.textWrapper = React.createRef()
  }

  state = {
    collapsed: false,
    expanding: false,
    maxHeight: 0,
  }

  componentDidMount() {
    if (this.props.minLines) {
      // When a media query is provided, only collapse the text if the media query matches.
      if (this.props.matchMedia && !matchMedia(this.props.matchMedia).matches) {
        return
      }

      // Calculate line height of the first non-parent element in the container.
      // This naively assumes that the first few lines of text are all the same height,
      // which is the primary use case (e.g. cinema descriptions).
      let firstLeafNode = this.textWrapper.current
      while (firstLeafNode.firstElementChild) {
        firstLeafNode = firstLeafNode.firstElementChild
      }
      const lineHeight =
        parseFloat(window.getComputedStyle(firstLeafNode).lineHeight) || 0

      // Check if it needs collapsing
      const maxHeight = lineHeight * (this.props.minLines + BUFFER_LINES)
      if (this.textWrapper.current.scrollHeight > maxHeight) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState((_state, props) => ({
          collapsed: true,
          maxHeight: lineHeight * props.minLines,
        }))
      }
    }
  }

  showAll = () => {
    const timeout = parseInt(style['expand-duration-ms'], 10)
    const fullHeight = this.textWrapper.current.scrollHeight
    this.setState({
      expanding: true,
      maxHeight: fullHeight,
    })
    setTimeout(() => {
      this.setState({
        collapsed: false,
        expanding: false,
        maxHeight: 0,
      })
    }, timeout)
  }

  render() {
    const { children, buttonText, buttonStyle, color } = this.props
    const { collapsed, expanding, maxHeight } = this.state

    const wrapperStyle = maxHeight ? { maxHeight: `${maxHeight}px` } : {}

    return (
      <React.Fragment>
        <div
          ref={this.textWrapper}
          className={classNames(style.textWrapper, {
            [style.textCollapsed]: collapsed,
            [style.greyTextCollapsed]: collapsed && color === 'Grey',
            [style.textExpanding]: expanding,
          })}
          style={wrapperStyle}
        >
          {children}
        </div>
        {collapsed && (
          <div
            className={classNames(style.showMoreWrapper, {
              [style.showMoreExpanding]: expanding,
            })}
          >
            <button
              type="button"
              className={classNames(style.showMore, buttonStyle)}
              onClick={this.showAll}
            >
              {buttonText}
            </button>
          </div>
        )}
      </React.Fragment>
    )
  }
}

ShowMoreText.propTypes = {
  minLines: PropTypes.number,
  children: PropTypes.node,
  buttonText: PropTypes.string,
  buttonStyle: PropTypes.string,
  matchMedia: PropTypes.string,
  color: PropTypes.string,
}

ShowMoreText.defaultProps = {
  buttonText: 'Show more',
}

export default ShowMoreText
